"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.openEventModal = void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = require("@floating-ui/react-dom");
const util_1 = require("@app/util");
const _ui_1 = require("@ui");
const shift_1 = require("@app/component/modals/shift-1.5/shift");
const unavailability_modal_1 = require("@app/component/modals/unavailability-1.5/unavailability-modal");
const format_hours_1 = require("@app/util/format-hours");
const use_modal_hoc_1 = require("@app/util/modal/use-modal-hoc");
const text_overflow_1 = require("@app/util/text-overflow");
const units_1 = require("@app/util/units");
const use_calendar_settings_1 = require("@app/util/use-calendar-settings");
const sort_by_1 = require("../sort-by");
const connect_1 = __importDefault(require("./connect"));
const IconsSector_1 = require("./IconsSector");
require("./index.scss");
const TooltipContent_1 = __importDefault(require("./TooltipContent"));
// this implements the logic of which modal should be opened for the view/editation of this event
// and also opens it. it should be called from the calendar (this file), but also from Tables with shifts (for example AttendanceTable)
function _openEventModal(eventData, eventType, props) {
    // Prevent opening two modals on double click
    if (!window.dsEventModalLastOpened) {
        window.dsEventModalLastOpened = 0;
    }
    const now = Date.now();
    if (now - window.dsEventModalLastOpened < 400) {
        // Ignore if last click was too recent (prevent double click)
        return;
    }
    window.dsEventModalLastOpened = now;
    setTimeout(() => {
        // call the modal open asynchronously in setTimeout() to make the modal appear immediatelly,
        // independently from the rest of the heavier code in whatever function this is called from
        const { setModal, isCycleCalendar, afterSubmit, cycleDetail, idx, cycleGroups } = props;
        if (eventType === 'shift' && !isCycleCalendar) {
            if (eventData.hasOffer &&
                eventData.hasOffer.status !== 'resolved' &&
                !props.isLockedDay) {
                setModal('offers', {
                    action: eventData.hasOffer.status === 'managerRequestApproval'
                        ? 'approve'
                        : eventData.hasOffer.status === 'managerResultApproval'
                            ? 'resolve'
                            : 'show',
                    selectedShiftIds: [eventData.id],
                });
            }
            else {
                props.openModal(shift_1.ShiftModal, {
                    initialData: { type: 'live', shiftId: eventData.id, afterSubmit },
                });
            }
        }
        if (eventType === 'shift' && isCycleCalendar) {
            const detail = cycleDetail.data.find((cycDetail) => cycDetail.data.id === eventData.id);
            const dataFromId = detail?.data.id.split('_');
            if ((0, util_1.isDefined)(dataFromId)) {
                props.openModal(shift_1.ShiftModal, {
                    initialData: {
                        type: 'cycle',
                        shiftId: detail?.data.id,
                        cycle: {
                            colId: parseInt(dataFromId[1]),
                            groupId: cycleGroups[idx].groupId,
                            eventId: parseInt(dataFromId[2]),
                        },
                        afterSubmit,
                    },
                });
            }
        }
        if (eventType === 'availability' ||
            eventType === 'unavailability' ||
            eventType === 'timeOff') {
            props.openModal(unavailability_modal_1.UnavailabilityModal, {
                initialData: eventData,
                afterSubmit,
            });
        }
    }, 1);
}
class Event extends react_1.default.Component {
    bottomContentRef;
    resizeTimeout;
    constructor(props) {
        super(props);
        this.state = {
            contextMenu: false,
            eventWidth: 0,
        };
        this.bottomContentRef = react_1.default.createRef();
        // console.log('day part', props.dayPart)
    }
    shouldComponentUpdate(nextProps, nextState) {
        // update if state.contextMenu changes
        if (this.state.contextMenu !== nextState.contextMenu) {
            return true;
        }
        if (this.state.eventWidth !== nextState.eventWidth) {
            return true;
        }
        if (this.props.calendar.view !== nextProps.calendar.view) {
            // update if calendar view changes
            return true;
        }
        // update if event's vertical shift changes
        if (this.props.verticalShift !== nextProps.verticalShift) {
            return true;
        }
        // update if calendar's sortedBy setting changed
        if (this.props.sortedBy !== nextProps.sortedBy) {
            return true;
        }
        // update if calendar's settings changed
        if ((0, use_calendar_settings_1.hasCalendarSettingsChanged)(this.props.calendarSettings, nextProps.calendarSettings)) {
            return true;
        }
        // update if event data changes
        if (util_1.miscUtil.hasEventChanged(this.props, nextProps)) {
            return true;
        }
        // update if store.positions are loaded
        if (nextProps.positions?.length && !this.props.positions?.length) {
            return true;
        }
        // update if calendarFilters.hideWarnings changes
        if (this.props.calendarFilters !== nextProps.calendarFilters) {
            const warningsFilterNow = this.props.calendarFilters?.find((f) => f.hideWarnings);
            const warningsFilterNext = nextProps.calendarFilters?.find((f) => f.hideWarnings);
            if (warningsFilterNow !== warningsFilterNext) {
                return true;
            }
        }
        // handle multi-selection
        if (this.props.calendarMultiSelect !== nextProps.calendarMultiSelect) {
            const currentEvents = this.props.calendarMultiSelect.sourceEvents;
            const nextEvents = nextProps.calendarMultiSelect.sourceEvents;
            // If this event is involved in multi-selection at all, re-render
            if (currentEvents !== nextEvents) {
                const eventId = this.props.data.id;
                const wasSelected = currentEvents?.some((ev) => ev.id === eventId) || false;
                const isSelected = nextEvents?.some((ev) => ev.id === eventId) || false;
                if (wasSelected || isSelected) {
                    return true;
                }
            }
        }
        return false;
    }
    componentDidUpdate(prevProps) {
        // when this event got deselected (via Schedule component's functionality), make sure it's state.contextMenu is false
        if (prevProps?.calendarMultiSelect?.sourceEvents?.some((evt) => evt.id === prevProps?.data?.id) &&
            !this.props?.calendarMultiSelect?.sourceEvents?.some((evt) => evt.id === this.props?.data?.id)) {
            if (this.state.contextMenu) {
                this.setState((s) => Object.assign({}, s, { contextMenu: false }));
            }
        }
    }
    updateWindowDimensions() {
        if ((0, util_1.isDefined)(this.resizeTimeout)) {
            clearTimeout(this.resizeTimeout);
        }
        this.resizeTimeout = setTimeout(() => {
            this.setState((prev) => ({
                ...prev,
                eventWidth: this.bottomContentRef.current?.offsetWidth ?? 0,
            }));
        }, 500);
    }
    componentDidMount() {
        this.setState((prev) => ({
            ...prev,
            eventWidth: this.bottomContentRef.current?.offsetWidth ?? 0,
        }));
        window.addEventListener('resize', this.updateWindowDimensions.bind(this));
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions.bind(this));
    }
    // handle dropping a shift into some calendar cell
    dropShift = (e) => {
        const sf = this.props.data;
        const view = this.props.calendar.view;
        // find out where it was dropped
        let pageX = e.pageX && e.pageX !== 0 ? e.pageX : window.dragPageX;
        let pageY = e.pageY && e.pageY !== 0 ? e.pageY : window.dragPageY;
        pageX = parseFloat(pageX);
        pageY = parseFloat(pageY);
        if (isNaN(pageX))
            pageX = 0.0;
        if (isNaN(pageY))
            pageY = 0.0;
        const droppedOn = document
            .elementsFromPoint(pageX, pageY)
            .find((el) => el.classList.contains('ds-droppable'));
        if (!droppedOn)
            return;
        const dropData = JSON.parse(droppedOn.dataset.droppable);
        // graphical feedback for the drop
        const rect = droppedOn.getBoundingClientRect();
        const outline = document.createElement('div');
        outline.className = 'drop-outline';
        outline.style.position = 'fixed';
        outline.style.left = `${rect.left - 3}px`;
        outline.style.top = `${rect.top - 3}px`;
        outline.style.width = `${rect.width + 6}px`;
        outline.style.height = `${rect.height + 6}px`;
        outline.style.pointerEvents = 'none';
        outline.style.zIndex = '9999';
        document.body.appendChild(outline);
        setTimeout(() => {
            document.body.removeChild(outline);
        }, 100);
        const update = {};
        let startOffer = false;
        // prepare the update
        const currentEmployee = sf.userId;
        const newEmployee = dropData.employee;
        if (currentEmployee !== newEmployee) {
            if (newEmployee === 'unassigned') {
                update.userId = null;
            }
            else if (newEmployee === 'offers') {
                if (!sf.hasOffer || sf.hasOffer.status === 'resolved') {
                    startOffer = true;
                }
                delete update.userId;
            }
            else {
                update.userId = newEmployee;
            }
        }
        // prepare period update when dropped in a day (month or week view)
        if (view === 'month' || view === 'week') {
            if (!this.props.calendar.date)
                return;
            const currentDay = (0, util_1.cachedMoment)(sf.period.start);
            const newDay = (0, util_1.cachedMoment)(this.props.calendar.date)
                .startOf(view)
                .add(dropData.colIdx, 'days');
            const dur = (0, util_1.cachedMoment)(sf.period.end).diff(sf.period.start) / 1000 / 60;
            if (!currentDay.isSame(newDay, 'day')) {
                const newPeriod = Object.assign({}, sf.period);
                newPeriod.start = currentDay
                    .clone()
                    .date(newDay.date())
                    .month(newDay.month())
                    .year(newDay.year());
                newPeriod.end = newPeriod.start.clone().add(dur, 'minutes');
                update.period = newPeriod;
            }
        }
        // prepare period update when dropped in an hour (day view)
        if (view === 'day') {
            const currentHour = (0, util_1.cachedMoment)(sf.period.start);
            const newHour = (0, util_1.cachedMoment)(this.props.calendar.date)
                .startOf(view)
                .add(dropData.colIdx, 'hours');
            const dur = (0, util_1.cachedMoment)(sf.period.end).diff(sf.period.start) / 1000 / 60;
            if (!currentHour.isSame(newHour, 'hour')) {
                const newPeriod = Object.assign({}, sf.period);
                newPeriod.start = currentHour
                    .clone()
                    .hour(newHour.hour())
                    .minute(newHour.minute());
                newPeriod.end = newPeriod.start.clone().add(dur, 'minutes');
                update.period = newPeriod;
            }
        }
        const shouldUpdate = typeof update.period !== typeof undefined ||
            typeof update.userId !== typeof undefined;
        // open the 'offers' modal
        if (startOffer) {
            const up = {};
            if (update.period)
                up.period = update.period;
            if (update.userId && update.userId !== 'offers')
                up.userId = update.userId;
            this.props.setModal('offers', {
                selectedShiftIds: [sf.id],
                action: 'create',
                createUpdateBefore: up.period || up.userId ? up : undefined,
            });
            // hide open event's tooltip after we one the 'offers' modal so it doesn't cover it
            setTimeout(() => {
                const tt = document.querySelector('.evt-tt-' + sf.id);
                if (tt)
                    tt.style.display = 'none';
            }, 250);
        }
        else {
            if (shouldUpdate)
                this.props.updateLiveShift(sf.id, update);
        }
    };
    // handle dropping a shiftTemplate into some calendar cell
    dropShiftTemplate = (e, tpl) => {
        const { createShift, calendar, setModal } = this.props;
        // find out where it was dropped
        let pageX = e.pageX && e.pageX !== 0 ? e.pageX : window.dragPageX;
        let pageY = e.pageY && e.pageY !== 0 ? e.pageY : window.dragPageY;
        pageX = parseFloat(pageX);
        pageY = parseFloat(pageY);
        if (isNaN(pageX))
            pageX = 0.0;
        if (isNaN(pageY))
            pageY = 0.0;
        const droppedOn = document
            .elementsFromPoint(pageX, pageY)
            .find((el) => el.classList.contains('ds-droppable'));
        if (!droppedOn)
            return;
        const dropData = JSON.parse(droppedOn.dataset.droppable);
        // create shift from template
        const day = (0, util_1.formatYYYYMMDD)((0, util_1.cachedMoment)(calendar.date)
            .startOf(calendar.view)
            .add(calendar.view === 'day' ? 0 : dropData.colIdx, 'days'));
        util_1.calendarUtil.createShiftFromShiftTemplate(tpl, dropData.employee &&
            dropData.employee !== 'unassigned' &&
            dropData.employee !== 'offers'
            ? dropData.employee
            : null, day, createShift, (res) => {
            if (dropData.employee === 'offers' && res && res.length && res[0].id) {
                const newShiftId = res[0].id;
                setModal('offers', {
                    selectedShiftIds: [newShiftId],
                    newlyCreatedShifts: res,
                    action: 'create',
                    createType: 'drop',
                });
            }
        });
    };
    _isActiveColContextMenu() {
        return !!document.querySelector('.ds-c-sections .ds-c-col > .tooltip');
    }
    _singleSelectThisEvent = (setCalendarMultiSelect, data, day = null) => {
        let v = Object.assign({}, data);
        if (day !== null) {
            v = Object.assign({}, v, { day });
        }
        setCalendarMultiSelect({
            action: null,
            sourceEvents: [v],
            isActive: true,
            targets: [],
            isSelectingTargets: false,
        });
    };
    getEventColor = (pos, RON) => {
        const _shiftColorBasedOn = this.props.calendarSettings.shiftColorBasedOn;
        const _defaultColor = '666666';
        if (_shiftColorBasedOn === use_calendar_settings_1.ShiftColorBasedOn.Position) {
            const bgColor = pos?.color
                ? pos.color
                : pos?.id
                    ? util_1.colorUtil.idToColor(pos.id, this.props.positions)
                    : _defaultColor;
            return bgColor;
        }
        else if (_shiftColorBasedOn === use_calendar_settings_1.ShiftColorBasedOn.RON) {
            switch (RON) {
                case 'morning':
                    return 'FEB700';
                case 'sun':
                    return 'F44C4C';
                case 'moon':
                    return '4C53F4';
                default:
                    return _defaultColor;
            }
        }
        return _defaultColor;
    };
    getShiftHTML = (data, params) => {
        const { key, positions, day, isExternalEmployeeRow, isLockedDay, calendarMultiSelect, setCalendar, setCalendarMultiSelect, isTransparent, workspace, calendarFilters, className, isPluginEnabled, isFirstShiftInDay, isCycleCalendar, isCyclePreview, calendarSettings, } = this.props;
        const RON = util_1.timeUtil.getDayPartOfEvent(data)?.ico;
        // we dont want to gray out shifts in unassigned or offers
        const isBottomSection = this.props.whichSection === 'bottom';
        const isSortedByDayPart = this.props.sortedBy === sort_by_1.SORT_BY.DAY_PART;
        const isCorrectDayPart = util_1.timeUtil.getDayPartOfEvent(this.props.data)?.name === this.props.sortData?.id;
        // if (isCorrectDayPart) {
        //   console.log(
        //     'actual',
        //     timeUtil.getDayPartOfEvent(this.props.data)?.name,
        //     'section',
        //     this.props.dayPart
        //   )
        // }
        const displayNormalColor = ((0, util_1.isDefined)(this.props.sortData?.id) && isCorrectDayPart) ||
            !isBottomSection ||
            !isSortedByDayPart;
        if (isCycleCalendar)
            params.view = 'month';
        const pos = (positions || []).find((p) => p.id === data.positionId);
        // const bgColor = displayNormalColor ? this.getEventColor(pos, RON) : 'd5d5d9'
        const bgColor = this.getEventColor(pos, RON);
        // const bgColor = this.getEventColor(pos, RON)
        const txtColor = util_1.colorUtil.contrastText(bgColor);
        // console.log(this.props)
        const hasTransferData = data?.hasOffer?.transfer || data.transfer;
        const hasMaster = hasTransferData?.master;
        const isReadOnly = hasMaster || isLockedDay || isExternalEmployeeRow;
        const isNotDraggable = isReadOnly ||
            (data.hasOffer && data.hasOffer.status !== 'resolved') ||
            isCycleCalendar;
        // filter out warnings according to calendarFilters
        if (data?.warnings?.length) {
            const warnFilter = (calendarFilters || []).find((f) => f.hideWarnings);
            if (warnFilter?.hideWarnings) {
                if (warnFilter.hideWarnings === 'all' || warnFilter.hideWarnings === true) {
                    data.warnings = null;
                }
                else {
                    data.warnings = data.warnings.filter((w) => !warnFilter?.hideWarnings?.includes(w.name));
                }
            }
        }
        if (data.published && (!data.plannedByPlanner || !data.plannedByPlanner)) {
            params.customStyles.backgroundColor = '#' + bgColor; // colors for published shifts, not plannedByPlanner
            params.customStyles.borderColor = '#' + bgColor;
        }
        else if (isCycleCalendar) {
            params.customStyles.backgroundColor = '#' + bgColor; // colors for cycle calendar
            params.customStyles.borderColor = '#' + bgColor;
        }
        else {
            params.customStyles.borderColor = '#' + bgColor; // colors for unpublished shifts or shifts plannedByPlanner
            params.customStyles.color = '#' + bgColor;
        }
        const displayPauses = params.view === 'day' && data.pauses?.length;
        const displayAgenda = params.view === 'day' && data.agenda?.length;
        const displayStandByActivities = params.view === 'day' &&
            data.standByActivities?.length &&
            isPluginEnabled('standby');
        const thisIsTopSectionRow = ['offers', 'unassigned'].includes(params.rowEmployee);
        const evtIdentifier = util_1.calendarUtil.getEvtIdentifier(data.id, data.period ? data.period.start : day, false);
        const durationMins = (0, util_1.cachedMoment)(data.period.end).diff(data.period.start, 'minutes');
        const timeDivider = params.view === 'month' ? react_1.default.createElement("br", null) : ' ';
        const displayTimeAsPeriod = calendarSettings.shiftShowTimeDataAs === use_calendar_settings_1.ShiftShowTimeDataAs.Period;
        const PeriodDisplay = durationMins > 90 || ['month', 'week'].includes(params.view) ? (react_1.default.createElement(react_1.Fragment, null,
            (0, util_1.formatHmm)((0, util_1.cachedMoment)(data.period.start)),
            "\u00A0-",
            timeDivider,
            (0, util_1.formatHmm)((0, util_1.cachedMoment)(data.period.end)))) : (react_1.default.createElement(react_1.Fragment, null, (0, util_1.formatHmm)((0, util_1.cachedMoment)(data.period.start))));
        const DurationDisplayMain = (react_1.default.createElement("div", { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.1rem',
                alignItems: 'center',
            } },
            react_1.default.createElement(_ui_1.Icon, { size: 'small', ico: 'clock' }),
            react_1.default.createElement("span", null, (0, format_hours_1.formatHours)(durationMins / 60))));
        const DurationDisplayBottom = react_1.default.createElement("span", null, (0, format_hours_1.formatHours)(durationMins / 60));
        const _locality = workspace.localities?.find((loc) => loc?.id === data.localityId);
        const LocalityDisplay = (0, util_1.isValue)(_locality) && (0, util_1.isValue)(_locality.name)
            ? `${(0, util_1.isValue)(_locality?.shortName) ? `(${_locality.shortName}) ` : ''}${_locality.name}`
            : null;
        let PositionDisplay = '';
        if (hasMaster?.positionName) {
            PositionDisplay =
                (0, util_1.isValue)(this.bottomContentRef.current) &&
                    (0, text_overflow_1.isTextOverflowing)(hasMaster.positionName, (0, units_1.toRem)(this.bottomContentRef.current.offsetWidth) * 0.95, 0.5)
                    ? util_1.stringUtil.getShortcut(hasMaster.positionName)
                    : hasMaster.positionName;
        }
        else {
            PositionDisplay = pos
                ? (0, util_1.isValue)(this.bottomContentRef.current) &&
                    (0, text_overflow_1.isTextOverflowing)(pos.name, (0, units_1.toRem)(this.bottomContentRef.current.offsetWidth) * 0.95, 0.5)
                    ? util_1.stringUtil.getShortcut(pos.name)
                    : pos.name
                : (0, util_1.t)('SORT_BY_POSITION_NO_POS');
        }
        const timeString = displayTimeAsPeriod ? PeriodDisplay : DurationDisplayMain;
        // if there are multiple shifts with this same ID, keep only one tooltip visible (happens when a shift has an ongoing offer or when it's displayed in multiple contract/position sections in calendar)
        const dealWithMultipleCopiesOfSameShift = (e) => {
            const targetAncestor = e.target.closest('.ds-c-col');
            setTimeout(() => {
                const found = document.querySelectorAll('.evt-tt.evt-tt-' + data.id);
                for (let i = 0; i < found.length; ++i) {
                    if (found[i].closest('.ds-c-col') !== targetAncestor) {
                        ;
                        found[i].style.display = 'none';
                    }
                }
            }, 50);
        };
        return (react_1.default.createElement("div", { "data-testid": `shift-event-${data.id}`, className: 'ds-c-event ' +
                (isFirstShiftInDay ? 'is-first-shift ' : '') +
                (className ? className + ' ' : '') +
                'is-text-' +
                txtColor +
                ' is-shift ' +
                (data.parentId ? 'is-standby-actvity ' : '') +
                (data.published ? 'is-published ' : 'is-unpublished ') +
                (data.plannedByPlanner ? 'is-planned-by-planner ' : '') +
                (isTransparent || !displayNormalColor ? 'is-transparent ' : '') +
                (thisIsTopSectionRow ? 'is-top-section ' : '') +
                (durationMins < 150 ? 'is-short-duration ' : '') +
                (hasMaster ? 'is-external-offer ' : '') +
                (data.hasOffer?.transfer?.slaves?.length ? 'is-local-offer ' : '') +
                (data.hasOffer && data.hasOffer.status !== 'resolved'
                    ? 'has-offer '
                    : '') +
                (data.hasOffer?.announceAction ? 'is-offer-announced ' : '') +
                ' is-view-' +
                params.view +
                ' ' +
                evtIdentifier +
                (params.isEventMultiSelected && !isCyclePreview && !isCycleCalendar
                    ? ' is-ms-selected'
                    : '') +
                (isCyclePreview ? ' is-preview' : '') +
                (params.isEventMultiSelected && params.isEvtMSSingle && !isCyclePreview
                    ? ' is-mss-single'
                    : ''), key: key, style: Object.assign({ zIndex: 2 }, params.customStyles), draggable: !isNotDraggable, onDragStart: (e) => {
                // when dragging a shift, make sure it's selected
                e.dataTransfer.setData('text/plain', data.id);
                e.target.style.opacity = '0.2';
                // hide the tooltip while dragging the shift
                document.body.classList.add('dragging-event');
                setTimeout(() => {
                    if (!isCycleCalendar &&
                        params.isMultiSelectEnabled &&
                        !params.isEventMultiSelected) {
                        setCalendarMultiSelect({
                            action: null,
                            targets: [],
                            sourceEvents: [data],
                            isSelectingTargets: false,
                        });
                    }
                }, 0);
            }, onDragEnd: (e) => {
                // immediate visual feedback
                ;
                e.target.style.opacity = '1.0';
                setTimeout(() => {
                    // actual drop shift logic
                    this.dropShift(e);
                    setTimeout(() => {
                        // unselect the shift after drag&drop
                        setCalendarMultiSelect({
                            action: null,
                            targets: [],
                            sourceEvents: [],
                            isSelectingTargets: false,
                        });
                        setTimeout(() => {
                            // un-hide the tooltip when we're finished dragging the shift
                            document.body.classList.remove('dragging-event');
                        }, 100);
                    }, 100);
                }, 0);
            }, onClick: (e) => {
                if (isCyclePreview)
                    return;
                e.stopPropagation();
                // Multi-select logic for manager calendar
                const isCtrlOrShift = e.ctrlKey || e.metaKey || e.shiftKey;
                // If multi-select is enabled and Ctrl/Shift/Meta is pressed, toggle selection
                if (params.isMultiSelectEnabled && isCtrlOrShift) {
                    const isSelected = calendarMultiSelect.sourceEvents.find((src) => src.id === data.id);
                    setCalendarMultiSelect({
                        // arg: update
                        action: null,
                        isActive: isSelected
                            ? calendarMultiSelect.sourceEvents?.length >= 2
                            : true,
                        targets: [],
                        isSelectingTargets: false,
                    }, isSelected ? null : Object.assign({}, data, { day }), // arg: addToSelection
                    isSelected ? data.id : null // arg: removeFromSelection
                    );
                    if (this.state.contextMenu)
                        this.setState((s) => ({ ...s, contextMenu: false }));
                    if (this._isActiveColContextMenu() &&
                        this.props.calendar?.contextMenuForColumn)
                        setCalendar({ contextMenuForColumn: undefined });
                    dealWithMultipleCopiesOfSameShift(e); // if there are 2 shifts with this same ID (because this is a shift with ongoing offer), keep only one tooltip visible
                    return;
                }
                // If not multi-select or no modifier keys, handle single selection/modal
                if (!params.isEventMultiSelected || params.isEvtMSSingle) {
                    _openEventModal(data, this.props.type, this.props);
                    if (!params.isEventMultiSelected) {
                        this._singleSelectThisEvent(setCalendarMultiSelect, data, day);
                    }
                }
                else {
                    // If clicked on one of multiple selected events, single-select it
                    this._singleSelectThisEvent(setCalendarMultiSelect, data, day);
                }
                // Clean up context menu and column context menu if needed
                if (this.state.contextMenu)
                    this.setState((s) => ({ ...s, contextMenu: false }));
                if (this._isActiveColContextMenu() &&
                    this.props.calendar?.contextMenuForColumn)
                    setCalendar({ contextMenuForColumn: undefined });
                dealWithMultipleCopiesOfSameShift(e); // if there are 2 shifts with this same ID (because this is a shift with ongoing offer), keep only one tooltip visible
            }, onContextMenu: (e) => {
                // right-click
                if (isCyclePreview)
                    return;
                e.stopPropagation();
                e.preventDefault();
                setCalendarMultiSelect({
                    action: null,
                    sourceEvents: calendarMultiSelect?.sourceEvents?.some((ev) => ev.id === data.id)
                        ? calendarMultiSelect.sourceEvents // if this right-clicked event is already multiselected, don't do anything with the selection
                        : [Object.assign({}, data, { day })], // if this event is not multiselected, make it selected
                    targets: [],
                    isSelectingTargets: false,
                });
                if (!this.state.contextMenu)
                    this.setState((s) => Object.assign({}, s, { contextMenu: true }));
                // if there are 2 shifts with this same ID (because this is a shift with ongoing offer), keep only one tooltip visible
                dealWithMultipleCopiesOfSameShift(e);
            } },
            react_1.default.createElement("div", { className: 'ds-c-evt-time' },
                timeString,
                displayPauses
                    ? data.pauses.length === 1
                        ? ', ' +
                            (0, util_1.t)('PAUSE_SHORT_X', {
                                dur: data.pauses[0].duration.toString() + 'm',
                                start: (0, util_1.formatHmm)((0, util_1.cachedMoment)(data.period.start).add(data.pauses[0].start, 'minutes')),
                            })
                        : ', ' +
                            data.pauses.length.toString() +
                            ' ' +
                            (0, util_1.t)('PAUSES_SHORT').toLowerCase()
                    : null),
            react_1.default.createElement(IconsSector_1.IconsSector, { shift: data, calendarFilters: this.props.calendarFilters ?? [] }),
            react_1.default.createElement("div", { ref: this.bottomContentRef, className: 'ds-c-evt-position' }, [
                [use_calendar_settings_1.ShiftShowAtBottom.Position, PositionDisplay],
                [use_calendar_settings_1.ShiftShowAtBottom.Locality, LocalityDisplay],
                [use_calendar_settings_1.ShiftShowAtBottom.Duration, DurationDisplayBottom],
            ].find((item) => item[0] === calendarSettings.shiftShowAtBottom)?.[1] ??
                null),
            displayPauses
                ? data.pauses.map((p, pidx) => {
                    const widthPercent = (p.duration / (data.duration ?? 1)) * 100;
                    const leftPercent = (p.start / (data.duration ?? 1)) * 100;
                    return (react_1.default.createElement("div", { key: data.id + 'p' + pidx.toString(), className: 'ds-c-evt-pause', style: {
                            left: leftPercent.toString() + '%',
                            width: widthPercent.toString() + '%',
                        } }, p.start >= 180 ? (0, util_1.t)('PAUSE_ON_EVENT') : null));
                })
                : null,
            displayAgenda
                ? data.agenda.map((ag, pidx) => {
                    const widthPercent = (ag.duration / (data.duration ?? 1)) * 100;
                    const leftPercent = (ag.start / (data.duration ?? 1)) * 100;
                    return (react_1.default.createElement("div", { key: data.id + 'ag' + pidx.toString(), className: 'ds-c-evt-agenda', style: {
                            left: leftPercent.toString() + '%',
                            width: 'calc(' + widthPercent.toString() + '% - 1px)',
                        } }, ag.start >= 180 ? react_1.default.createElement("span", null, ag.name) : null));
                })
                : null,
            displayStandByActivities
                ? data.standByActivities.map((ag, pidx) => {
                    const widthPercent = (ag.duration / (data.duration ?? 1)) * 100;
                    const leftPercent = (ag.start / (data.duration ?? 1)) * 100;
                    return (react_1.default.createElement("div", { key: data.id + 'ag' + pidx.toString(), className: 'ds-c-evt-agenda', style: {
                            left: leftPercent.toString() + '%',
                            width: 'calc(' + widthPercent.toString() + '% - 1px)',
                        } }));
                })
                : null));
    };
    getShiftTemplateHTML = (data, params) => {
        const { setCalendar, setCalendarMultiSelect, calendarMultiSelect, workspace, calendar, positions, calendarSettings, } = this.props;
        const isTplSelected = calendarMultiSelect?.sourceEvents?.find((evt) => evt.id === data.id);
        const RON = util_1.timeUtil.getDayPartOfEvent(data)?.ico;
        const pos = workspace && positions && positions.find((p) => p.id === data.positionId);
        const bgColor = this.getEventColor(pos, RON);
        const txtColor = util_1.colorUtil.contrastText(bgColor);
        const displayPauses = calendar.view === 'day' &&
            data.pausesFixed &&
            data.pauses &&
            data.pauses.length;
        const durationMins = (0, util_1.cachedMoment)(data.period.end).diff(data.period.start, 'minutes');
        const timeDivider = params.view === 'month' ? react_1.default.createElement("br", null) : ' ';
        const displayTimeAsPeriod = calendarSettings.shiftShowTimeDataAs === use_calendar_settings_1.ShiftShowTimeDataAs.Period;
        const PeriodDisplay = durationMins > 90 || ['month', 'week'].includes(params.view) ? (react_1.default.createElement(react_1.Fragment, null,
            (0, util_1.formatHmm)((0, util_1.cachedMoment)(data.period.start)),
            "\u00A0-",
            timeDivider,
            (0, util_1.formatHmm)((0, util_1.cachedMoment)(data.period.end)))) : (react_1.default.createElement(react_1.Fragment, null, (0, util_1.formatHmm)((0, util_1.cachedMoment)(data.period.start))));
        const DurationDisplayMain = (react_1.default.createElement("div", { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.1rem',
                alignItems: 'center',
            } },
            react_1.default.createElement(_ui_1.Icon, { size: 'small', ico: 'clock' }),
            react_1.default.createElement("span", null, (0, format_hours_1.formatHours)(durationMins / 60))));
        const shiftTemplateObject = {
            id: data.id,
            name: data.shiftTemplateName,
            shift: Object.assign({}, data, {
                id: undefined,
                shiftTemplateName: undefined,
            }),
        };
        return (react_1.default.createElement("div", { className: 'ds-c-event ' +
                `is-text-${txtColor} ` +
                (calendar.view === 'week' ? 'is-view-week ' : 'is-view-month ') +
                (isTplSelected ? 'is-ms-selected ' : ''), style: {
                backgroundColor: '#' + bgColor,
                borderColor: '#' + bgColor,
            }, draggable: true, onDragStart: (e) => {
                setTimeout(() => {
                    // hide the tooltip while dragging the shift
                    document.body.classList.add('dragging-event');
                    e.dataTransfer.setData('text/plain', data.id);
                    // when dragging a shiftTemplate, make sure it's selected
                    if (!isTplSelected) {
                        setCalendarMultiSelect({
                            sourceEvents: [shiftTemplateObject],
                            targets: [],
                        });
                    }
                }, 0);
            }, onDragEnd: (e) => {
                // immediate visual feedback
                ;
                e.target.style.opacity = '1.0';
                setTimeout(() => {
                    // actual drop template logic
                    this.dropShiftTemplate(e, shiftTemplateObject);
                    setTimeout(() => {
                        // unselect the shift after drag&drop
                        setCalendarMultiSelect({
                            action: null,
                            targets: [],
                            sourceEvents: [],
                            isSelectingTargets: false,
                        });
                        setTimeout(() => {
                            // un-hide the tooltip when we're finished dragging the shift
                            document.body.classList.remove('dragging-event');
                        }, 100);
                    }, 100);
                }, 0);
            }, onClick: (e) => {
                // Multi-select logic for manager calendar
                const isCtrlOrShift = e.ctrlKey || e.metaKey || e.shiftKey;
                // If multi-select is enabled and Ctrl/Shift/Meta is pressed, toggle selection
                if (params.isMultiSelectEnabled && isCtrlOrShift) {
                    const isSelected = calendarMultiSelect.sourceEvents.find((src) => src.id === data.id);
                    setCalendarMultiSelect({
                        action: null,
                        isActive: isSelected
                            ? calendarMultiSelect.sourceEvents?.length >= 2
                            : true,
                        targets: [],
                        sourceEvents: isSelected ? [] : [Object.assign({}, data)],
                        isSelectingTargets: false,
                    });
                    if (this.state.contextMenu)
                        this.setState((s) => ({ ...s, contextMenu: false }));
                    if (this._isActiveColContextMenu() &&
                        this.props.calendar?.contextMenuForColumn)
                        setCalendar({ contextMenuForColumn: undefined });
                    return;
                }
                // If not multi-select or no modifier keys, handle single selection/modal
                if (!params.isEventMultiSelected || params.isEvtMSSingle) {
                    this.props.openModal(shift_1.ShiftModal, {
                        initialData: {
                            type: 'shiftTemplate',
                            shiftTemplateId: shiftTemplateObject.id,
                        },
                    });
                    if (!params.isEventMultiSelected) {
                        this._singleSelectThisEvent(setCalendarMultiSelect, data);
                    }
                }
                else {
                    // If clicked on one of multiple selected events, single-select it
                    this._singleSelectThisEvent(setCalendarMultiSelect, data);
                }
                // Clean up context menu and column context menu if needed
                if (this.state.contextMenu)
                    this.setState((s) => ({ ...s, contextMenu: false }));
                if (this._isActiveColContextMenu() &&
                    this.props.calendar?.contextMenuForColumn)
                    setCalendar({ contextMenuForColumn: undefined });
            }, onContextMenu: (e) => {
                // right-click
                e.stopPropagation();
                e.preventDefault();
                setCalendarMultiSelect({
                    action: null,
                    sourceEvents: calendarMultiSelect?.sourceEvents?.some((ev) => ev.id === data.id)
                        ? calendarMultiSelect?.sourceEvents // if this right-clicked event is already multiselected, don't do anything with the selection
                        : [shiftTemplateObject], // if this event is not multiselected, make it selected
                    targets: [],
                    isSelectingTargets: false,
                });
                if (!this.state.contextMenu)
                    this.setState((s) => Object.assign({}, s, { contextMenu: true }));
            } },
            react_1.default.createElement("div", { className: 'ds-c-evt-time' }, displayTimeAsPeriod ? PeriodDisplay : DurationDisplayMain),
            react_1.default.createElement(IconsSector_1.IconsSector, { shift: data, calendarFilters: this.props.calendarFilters ?? [] }),
            react_1.default.createElement("div", { ref: this.bottomContentRef, className: 'ds-c-evt-position' }, (0, util_1.isValue)(this.bottomContentRef.current) &&
                (0, text_overflow_1.isTextOverflowing)(shiftTemplateObject.name, (0, units_1.toRem)(this.bottomContentRef.current.offsetWidth) * 0.95, 0.5)
                ? util_1.stringUtil.getShortcut(shiftTemplateObject.name)
                : shiftTemplateObject.name),
            displayPauses
                ? data.pauses.length === 1
                    ? ', ' +
                        (0, util_1.t)('PAUSE_SHORT_X', {
                            dur: data.pauses[0].duration.toString() + 'm',
                            start: (0, util_1.formatHmm)((0, util_1.cachedMoment)(data.period.start).add(data.pauses[0].start, 'minutes')),
                        })
                    : ', ' +
                        data.pauses.length.toString() +
                        ' ' +
                        (0, util_1.t)('PAUSES_SHORT').toLowerCase()
                : null));
    };
    getAvailOrTimeOffHTML = (data, params) => {
        const { key, day, workspace, setCalendar, setCalendarMultiSelect, calendarMultiSelect, className, calendarFilters, calendarSettings, } = this.props;
        const isWholeDay = (0, util_1.formatHHmm)((0, util_1.cachedMoment)(data.period.start)) === '00:00' &&
            ((0, util_1.formatHHmm)((0, util_1.cachedMoment)(data.period.end)) === '00:00' ||
                (0, util_1.formatHHmm)((0, util_1.cachedMoment)(data.period.end)) === '23:59');
        const category = util_1.calendarUtil.getTimeOffOrAvailCategory(data, workspace);
        const detailedCategory = workspace.unavailabilityCategories?.find((uc) => uc.id === data.categoryId);
        const displayAsDays = detailedCategory?.displayWorkTimeAsDays;
        const availOrTimeOff = util_1.calendarUtil.isEventAvailabilityOrTimeOff(data);
        const timeOffTotalHours = availOrTimeOff === 'timeOff' && data.workMinutes && data.workMinutes / 60;
        // const timeDivider =
        //   params.view === 'month' && availOrTimeOff === 'timeOff' ? <br /> : ' '
        const timeDivider = ' ';
        const PeriodDisplay = (react_1.default.createElement(react_1.Fragment, null,
            (0, util_1.formatHmm)((0, util_1.cachedMoment)(data.period.start)),
            "\u00A0-",
            timeDivider,
            (0, util_1.formatHmm)((0, util_1.cachedMoment)(data.period.end))));
        const getTimeOffLabel = () => {
            if (displayAsDays) {
                return data.workDays.toString() + (0, util_1.t)('DAY_SHORTEST');
            }
            return (0, format_hours_1.formatHours)(timeOffTotalHours);
        };
        const DurationDisplay = (react_1.default.createElement("div", { style: {
                width: '100%',
                display: 'flex',
                gap: '2px',
                alignItems: 'center',
                justifyContent: 'center',
            } },
            react_1.default.createElement(_ui_1.Icon, { size: 'small', ico: 'clock' }),
            react_1.default.createElement("span", null, category?.displayWorkTimeAsDays
                ? data.workDays.toString() + (0, util_1.t)('DAY_SHORTEST')
                : getTimeOffLabel())));
        return (react_1.default.createElement("div", { "data-testid": `timeoff-event-${data.id}`, className: 'ds-c-event' +
                (className ? className + ' ' : '') +
                ' is-unavailability' +
                ' is-mode-' +
                (data.available ? 'available' : 'unavailable') +
                ' is-view-' +
                params.view +
                ' is-' +
                (availOrTimeOff === 'timeOff' ? 'HARD' : 'SOFT') +
                (isWholeDay ? ' is-whole-day' : '') +
                ' ' +
                util_1.calendarUtil.getEvtIdentifier(data.id, day) +
                (params.isEventMultiSelected ? ' is-ms-selected' : '') +
                (params.isEventMultiSelected && params.isEvtMSSingle
                    ? ' is-mss-single'
                    : '') +
                (data.workMinutes > 0 && !params.isEventMultiSelected
                    ? ' is-taking-total-hours'
                    : ''), key: key, style: Object.assign({ zIndex: 2 }, params.customStyles), onClick: (e) => {
                e.stopPropagation(); // this needs to be here so the click on the Event doesn't count as a click on the Column (clicking column de-selects events)
                // Multi-select logic for manager calendar
                const isCtrlOrShift = e.ctrlKey || e.metaKey || e.shiftKey;
                // If multi-select is enabled and Ctrl/Shift/Meta is pressed, toggle selection
                if (params.isMultiSelectEnabled && isCtrlOrShift) {
                    const isSelected = calendarMultiSelect.sourceEvents.find((src) => src.id === data.id);
                    setCalendarMultiSelect({
                        // arg: update
                        action: null,
                        isActive: isSelected
                            ? calendarMultiSelect.sourceEvents?.length >= 2
                            : true,
                        targets: [],
                        isSelectingTargets: false,
                    }, isSelected ? null : Object.assign({}, data, { day }), // arg: addToSelection
                    isSelected ? data.id : null // arg: removeFromSelection
                    );
                    if (this.state.contextMenu)
                        this.setState((s) => ({ ...s, contextMenu: false }));
                    if (this._isActiveColContextMenu() &&
                        this.props.calendar?.contextMenuForColumn)
                        setCalendar({ contextMenuForColumn: undefined });
                    return;
                }
                // If not multi-select or no modifier keys, handle single selection/modal
                if (!params.isEventMultiSelected || params.isEvtMSSingle) {
                    _openEventModal(data, availOrTimeOff, this.props);
                    if (!params.isEventMultiSelected) {
                        this._singleSelectThisEvent(setCalendarMultiSelect, data, day);
                    }
                }
                else {
                    // If clicked on one of multiple selected events, single-select it
                    this._singleSelectThisEvent(setCalendarMultiSelect, data, day);
                }
                // Clean up context menu and column context menu if needed
                if (this.state.contextMenu)
                    this.setState((s) => ({ ...s, contextMenu: false }));
                if (this._isActiveColContextMenu() &&
                    this.props.calendar?.contextMenuForColumn)
                    setCalendar({ contextMenuForColumn: undefined });
            }, onContextMenu: (e) => {
                // right-click
                e.stopPropagation();
                e.preventDefault();
                setCalendarMultiSelect({
                    action: null,
                    sourceEvents: calendarMultiSelect?.sourceEvents?.some((ev) => ev.id === data.id)
                        ? calendarMultiSelect.sourceEvents // if this right-clicked event is already multiselected, don't do anything with the selection
                        : [Object.assign({}, data, { day })], // if this event is not multiselected, make it selected
                    targets: [],
                    isSelectingTargets: false,
                });
                if (!this.state.contextMenu)
                    this.setState((s) => Object.assign({}, s, { contextMenu: true }));
            } },
            react_1.default.createElement("div", { className: 'ds-c-evt-timeoff-header' },
                calendarSettings.timeOffShowTimeDataAs ===
                    use_calendar_settings_1.TimeOffShowTimeDataAs.Duration ? (react_1.default.createElement("div", { className: 'ds-c-evt-duration-txt' }, isWholeDay
                    ? params.view === 'month'
                        ? (0, util_1.t)('CAL_NA_ALL_DAY_SHORT')
                        : (0, util_1.t)('ALL_DAY')
                    : PeriodDisplay)) : null,
                react_1.default.createElement("div", { className: 'ds-c-evt-time ds-c-evt-unav-txt' }, calendarSettings.timeOffShowTimeDataAs ===
                    use_calendar_settings_1.TimeOffShowTimeDataAs.Duration
                    ? DurationDisplay
                    : isWholeDay
                        ? params.view === 'month'
                            ? (0, util_1.t)('CAL_NA_ALL_DAY_SHORT')
                            : (0, util_1.t)('ALL_DAY')
                        : PeriodDisplay)),
            availOrTimeOff === 'timeOff' ? (react_1.default.createElement(IconsSector_1.IconsSector, { timeOffOrAvail: data, calendarFilters: calendarFilters ?? [] })) : null,
            availOrTimeOff === 'timeOff' && (react_1.default.createElement("div", { ref: this.bottomContentRef, className: 'ds-c-evt-position' }, calendarSettings.timeOffShowAtBottom === use_calendar_settings_1.TimeOffShowAtBottom.Shortcut
                ? category.tag
                : calendarSettings.timeOffShowAtBottom === use_calendar_settings_1.TimeOffShowAtBottom.Name
                    ? (0, util_1.isValue)(this.bottomContentRef.current) &&
                        (0, text_overflow_1.isTextOverflowing)(category.name, (0, units_1.toRem)(this.bottomContentRef.current.offsetWidth) * 0.95, 0.5)
                        ? category.tag
                        : category.name
                    : null))));
    };
    render() {
        const { type, data, calendarMultiSelect, rowEmployee, isFirstShiftInDay, isCyclePreview, isCycleCalendar, cycleCalendar, } = this.props;
        const { view } = isCycleCalendar ? cycleCalendar : this.props.calendar;
        let customStyles = {};
        let marginLeft = null;
        let width = null;
        if (view === 'day') {
            marginLeft = (((0, util_1.cachedMoment)(data.period.start).minute() / 60) * 100).toString() + '%';
            const widthPercent = ((0, util_1.cachedMoment)(data.period.end).diff(data.period.start) / 60000 / 60) * 100;
            width =
                'calc(' +
                    widthPercent.toString() +
                    '% + ' +
                    (widthPercent / 100).toString() +
                    'px)';
        }
        if (marginLeft && width) {
            customStyles = {
                marginLeft,
                width,
                minWidth: width,
                maxWidth: width,
                zIndex: 2,
            };
        }
        if (typeof data.verticalShift !== typeof undefined) {
            // This sets, now, unnecessary margin-top on event in unassigned section day view
            customStyles.marginTop = (data.verticalShift * 3.1875).toString() + 'rem'; // note: row height is set to 3.1875rem in CSS
            customStyles.position = 'absolute';
        }
        const isMultiSelectEnabled = document.querySelector('.ds-ms-selector') ||
            !window.matchMedia('only screen and (max-device-width: 699px)').matches;
        const isEventMultiSelected = !!isMultiSelectEnabled &&
            calendarMultiSelect.isActive &&
            calendarMultiSelect.sourceEvents &&
            calendarMultiSelect.sourceEvents.find((ev) => ev.id === data.id);
        const isEvtMSSingle = isEventMultiSelected &&
            calendarMultiSelect.sourceEvents.length === 1 &&
            !calendarMultiSelect.isSelectingTargets;
        // render the event element
        let ttAnchor = null;
        if (type === 'shift') {
            ttAnchor = this.getShiftHTML(data, {
                view,
                customStyles,
                isMultiSelectEnabled,
                isEventMultiSelected,
                isEvtMSSingle,
                rowEmployee,
                isFirstShiftInDay,
            });
        }
        if (type === 'availability' || type === 'timeOff') {
            ttAnchor = this.getAvailOrTimeOffHTML(data, {
                view,
                customStyles,
                isMultiSelectEnabled,
                isEventMultiSelected,
                isEvtMSSingle,
            });
        }
        if (type === 'shiftTemplate') {
            ttAnchor = this.getShiftTemplateHTML(data, {
                view,
                isMultiSelectEnabled,
                isEventMultiSelected,
                isEvtMSSingle,
            });
        }
        // prepare the event tooltip if needed
        let tooltipHTML = null;
        tooltipHTML = (react_1.default.createElement(_ui_1.Tooltip, { canBeHovered: this.state.contextMenu, clickable: this.state.contextMenu, openOnMount: this.state.contextMenu, anchor: ttAnchor, width: '11.875rem', 
            // in day view the event spans several hour cols and may be absolutely positioned, so it doesn't match its .anchor wrapper
            positionByAnchorChild: view === 'day', position: view === 'day' ? _ui_1.Tooltip.POSITIONS.BOTTOM_START : _ui_1.Tooltip.POSITIONS.RIGHT, middleware: view === 'day'
                ? [(0, react_dom_1.flip)({ fallbackPlacements: [_ui_1.Tooltip.POSITIONS.TOP] }), (0, react_dom_1.shift)(), (0, react_dom_1.hide)()]
                : undefined, closeCallback: () => {
                // when the tooltip is closed, set the window.dsMsTooltipWasRecentlyClosed flag to current timestamp.
                // it's used to prevent opening the editation modals when clicked on hoverbtns immediatelly after the event tooltip is closed.
                ;
                window.dsMsTooltipWasRecentlyClosed = Date.now();
            } },
            react_1.default.createElement("div", { className: 'evt-tt evt-tt-' + data.id },
                react_1.default.createElement(TooltipContent_1.default, { data: data, type: type, positions: this.props.positions || [], workspace: this.props.workspace, calendarMultiSelect: this.props.calendarMultiSelect, setCalendarMultiSelect: this.props.setCalendarMultiSelect, setModal: this.props.setModal, openPlanning: this.props.openPlanning, deleteLiveShift: this.props.deleteLiveShift, updateLiveShift: this.props.updateLiveShift, updateShiftTemplate: this.props.updateShiftTemplate, auth: this.props.auth, isPluginEnabled: this.props.isPluginEnabled, isLockedDay: this.props.isLockedDay, isCycleCalendar: this.props.isCycleCalendar, cycleDetail: this.props.cycleDetail, deleteCycleDetail: this.props.deleteCycleDetail, contextMenu: this.state.contextMenu, setContextMenu: (v) => {
                        this.setState((s) => Object.assign({}, s, { contextMenu: v }));
                    }, openEventModal: _openEventModal, eventProps: this.props }))));
        if (isCyclePreview && isCycleCalendar) {
            return ttAnchor;
        }
        return tooltipHTML || ttAnchor;
    }
}
exports.openEventModal = _openEventModal;
exports.default = (0, connect_1.default)((0, use_modal_hoc_1.withUseModalHOC)((0, use_calendar_settings_1.withUseCalendarSettings)(Event)));
